<template>
  <button
    type="button"
    class="ui-add-row-button"
  >
    <PlusIcon class="size-4" />
  </button>
</template>

<script setup lang="ts">
import { PlusIcon } from '@heroicons/vue/24/outline'
</script>

<style>
.ui-add-row-button {
  @apply absolute z-999 left-1 -translate-y-1/2;
  @apply size-5 flex items-center justify-center;
  @apply rounded-full border border-common-border;
  @apply bg-body text-indigo-400 dark:text-indigo-300;
  @apply hover:bg-indigo-50 dark:hover:bg-indigo-900/50;
  @apply text-sm font-semibold leading-none;
  @apply cursor-pointer;
}
</style>
